export default __webpack_public_path__ + "static/media/arrow_right_disabled.a1af65d3.svg";